import React, { useState } from "react";
import { useParams, Redirect } from "react-router";
import config from "../../config/apiConfig";
import Logo from "../../icons/logo.jpg";
import "./Verify.css";
import Cookies from "js-cookie";
import Api from "../../api";

function Verify() {
    const { verify_token } = useParams("verify_token");
    const [error, setError] = useState("");
    const [isVerified, setIsVerified] = useState(false);

    function handleVerify(e) {
        e.preventDefault();
        const formData = new FormData();
        formData.append("verify_token", verify_token);
        formData.append("token", config.token);
        formData.append("session-token", "AUTH");
        formData.append("device", "web");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/verify_user", requestOptions)
            .then((res) => res.json())
            .then((resp) => {
                if (resp.is_error) {
                    setError(resp.error_msg);
                } else {
                    setIsVerified(true);
                    setError(resp.info_msg);
                    // Cookies.set("token", resp.data.session_token);
                    // Cookies.set("id", resp.data.user_id);
                }
            });
    }

    return isVerified ? (
        <Redirect to="/login" />
    ) : (
        <div className="verify">
            <img src={Logo} />
            <h2>Verify your email id to complete signup</h2>
            <button className="verify__btn" onClick={handleVerify}>
                Verify
            </button>
            <p style={{ color: "red" }}>{error}</p>
        </div>
    );
}

export default Verify;
